var rurl = require('relative-url')
var map = {http:'ws', https:'wss'}
var def = 'ws'
module.exports = function (url, location) {
  return rurl(url, location, map, def)
}





//////////////////
// WEBPACK FOOTER
// ./~/pull-ws/ws-url.js
// module id = 798
// module chunks = 0